import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, vShow as _vShow, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-132c453c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "controls" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Data start row number: ")
const _hoisted_4 = ["disabled"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = { class: "errortext" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Frequency column number: ")
const _hoisted_8 = ["disabled"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = { class: "errortext" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Re(Z) column number: ")
const _hoisted_12 = ["disabled"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = { class: "errortext" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Im(Z) column number: ")
const _hoisted_16 = ["disabled"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = { class: "errortext" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Decimal Point: ")
const _hoisted_20 = ["disabled"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "." }, "Dot (.)", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "," }, "Comma (,)", -1))
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]

import {ref, inject, computed} from "vue";
import { configInjectionKey, defaultConfig } from "./ConfigManager";
import { toastInjectionKey } from "./Toaster/ToastManager";
import { i18n } from "@/main";


export default /*#__PURE__*/_defineComponent({
  __name: 'CSVConfigSelector',
  setup(__props) {

const toaster = inject(toastInjectionKey);
const editting = ref(false);
const folded = ref(true);
const toggle = ()=>{folded.value = !folded.value};

let csvConfig = inject(configInjectionKey, defaultConfig).csvConfig;
const r_s = ref(csvConfig.StartRow);
const c_freq = ref(csvConfig.FreqCol);
const c_rez = ref(csvConfig.ReZCol);
const c_imz = ref(csvConfig.ImZCol);
const decimalPoint = ref(csvConfig.DecimalPoint);

const enterEdit = ()=>{
    editting.value = true;
}
const leaveEdit = ()=>{
    editting.value = false;
    //init
    r_s.value = csvConfig.StartRow;
    c_freq.value = csvConfig.FreqCol;
    c_rez.value = csvConfig.ReZCol;
    c_imz.value = csvConfig.ImZCol;
    decimalPoint.value = csvConfig.DecimalPoint;
}
const saveEdit = ()=>{
    //validation
    if(validate()){
        csvConfig.StartRow = r_s.value;
        csvConfig.FreqCol = c_freq.value;
        csvConfig.ReZCol = c_rez.value;
        csvConfig.ImZCol = c_imz.value;
        csvConfig.DecimalPoint = decimalPoint.value;
        editting.value = false;
        console.log(csvConfig);
    }else{
        toaster?.alert("", i18n.global.tc("error_message.correct_error"), 2000);
    }
};

const validate = ()=>{
    return val11.value && val12.value && val21.value && val22.value && val23.value 
        && val31.value && val32.value && val33.value && val41.value && val42.value &&val43.value;
}

const checkPositive = (value:number)=>{
    if(value){
        return value > 0;
    }else{
        return true;
    }
}
const checkNumber = (value:string|number|undefined)=>{
    return !isNaN(parseFloat(value as string));
}

const checkDuplication = (value:number)=>{
    return [c_freq.value, c_imz.value, c_rez.value].filter(v=>v===value).length === 1;
}

const val11 = computed(()=>checkPositive(r_s.value));
const val12 = computed(()=>checkNumber(r_s.value));

const val21 = computed(()=>checkPositive(c_freq.value));
const val22 = computed(()=>checkNumber(c_freq.value));
const val23 = computed(()=>checkDuplication(c_freq.value));

const val31 = computed(()=>checkPositive(c_rez.value));
const val32 = computed(()=>checkNumber(c_rez.value));
const val33 = computed(()=>checkDuplication(c_rez.value));

const val41 = computed(()=>checkPositive(c_imz.value));
const val42 = computed(()=>checkNumber(c_imz.value));
const val43 = computed(()=>checkDuplication(c_imz.value));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", { onClick: toggle }, "> CSV Config"),
    _createElementVNode("div", {
      class: _normalizeClass(["formarea", {folded: folded.value, editting: editting.value}])
    }, [
      (!editting.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: enterEdit,
            class: "editbtn"
          }, "Edit"))
        : _createCommentVNode("", true),
      (editting.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            onClick: saveEdit,
            class: "savebtn"
          }, "Save"))
        : _createCommentVNode("", true),
      (editting.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            onClick: leaveEdit,
            class: "cancelbtn"
          }, "Cancel"))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("label", null, [
          _hoisted_3,
          _withDirectives(_createElementVNode("input", {
            type: "number",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((r_s).value = $event)),
            disabled: !editting.value
          }, null, 8, _hoisted_4), [
            [_vModelText, r_s.value]
          ]),
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("span", null, "The value must be larger than 0.", 512), [
              [_vShow, !_unref(val11)]
            ]),
            _withDirectives(_createElementVNode("span", null, "The value must be a number.", 512), [
              [_vShow, !_unref(val12)]
            ])
          ])
        ]),
        _createElementVNode("label", null, [
          _hoisted_7,
          _withDirectives(_createElementVNode("input", {
            type: "number",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((c_freq).value = $event)),
            disabled: !editting.value
          }, null, 8, _hoisted_8), [
            [_vModelText, c_freq.value]
          ]),
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _withDirectives(_createElementVNode("span", null, "The value must be larger than 0.", 512), [
              [_vShow, !_unref(val21)]
            ]),
            _withDirectives(_createElementVNode("span", null, "The value must be a number.", 512), [
              [_vShow, !_unref(val22)]
            ]),
            _withDirectives(_createElementVNode("span", null, "The column number must differ from others.", 512), [
              [_vShow, !_unref(val23)]
            ])
          ])
        ]),
        _createElementVNode("label", null, [
          _hoisted_11,
          _withDirectives(_createElementVNode("input", {
            type: "number",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((c_rez).value = $event)),
            disabled: !editting.value
          }, null, 8, _hoisted_12), [
            [_vModelText, c_rez.value]
          ]),
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            _withDirectives(_createElementVNode("span", null, "The value must be larger than 0.", 512), [
              [_vShow, !_unref(val31)]
            ]),
            _withDirectives(_createElementVNode("span", null, "The value must be a number.", 512), [
              [_vShow, !_unref(val32)]
            ]),
            _withDirectives(_createElementVNode("span", null, "The column number must differ from others.", 512), [
              [_vShow, !_unref(val33)]
            ])
          ])
        ]),
        _createElementVNode("label", null, [
          _hoisted_15,
          _withDirectives(_createElementVNode("input", {
            type: "number",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((c_imz).value = $event)),
            disabled: !editting.value
          }, null, 8, _hoisted_16), [
            [_vModelText, c_imz.value]
          ]),
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, [
            _withDirectives(_createElementVNode("span", null, "The value must be larger than 0.", 512), [
              [_vShow, !_unref(val41)]
            ]),
            _withDirectives(_createElementVNode("span", null, "The value must be a number.", 512), [
              [_vShow, !_unref(val42)]
            ]),
            _withDirectives(_createElementVNode("span", null, "The column number must differ from others.", 512), [
              [_vShow, !_unref(val43)]
            ])
          ])
        ]),
        _createElementVNode("label", null, [
          _hoisted_19,
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((decimalPoint).value = $event)),
            disabled: !editting.value
          }, _hoisted_23, 8, _hoisted_20), [
            [_vModelSelect, decimalPoint.value]
          ])
        ])
      ])
    ], 2)
  ]))
}
}

})